module.exports = __webpack_public_path__ + "static/media/grid-item-b6.34dda15e.png";